import React, { useCallback } from 'react';
import LayoutDashboard from 'layout/Dashboard';
import { useDispatch, useSelector } from 'react-redux';
import getDispatchWrapper from 'utils/getDispatchWrapper';
import { ContextMessages } from 'services/messages/context';
import LayoutTable from 'layout/Table';
import Table from 'components/tables/Table/Table';
import {
  crudApiCall,
  crudFormParams,
  crudInitialValuesMapper,
} from './crudConfig';
import CrudTab from 'layout/CrudTab';
import { CrudFormAdd, CrudFormUpdate } from 'components/forms/CrudForm';
import validators from 'services/validators';
import clsx from 'clsx';
import { backBtn, crudBtnAdd } from 'layout/Table/utils';
import { columns, tableApiCall } from './tableConfig';
import { crudFormSetMode } from 'store/actions';
import { constants } from 'configShared/store';

type TPsus = {
  className?: string;
  title?: string;
};

const reducerId = constants.PSUS;

const Psus: React.FC<TPsus> = ({ title, className }) => {
  const dispatchRedux = useDispatch();
  const dispatch = useCallback(getDispatchWrapper(reducerId, dispatchRedux), [
    reducerId,
    dispatchRedux,
  ]);
  const messages = React.useContext(ContextMessages);
  const tabLabel = useSelector((state: any) => state[reducerId].crud.tab);
  const tableState = useSelector((state: any) => state[reducerId].table);

  const tableApiCallMemo = React.useMemo(() => tableApiCall(dispatch), [
    dispatch,
  ]);

  return (
    <LayoutDashboard className={clsx(className, 'page_Psus')}>
      <LayoutTable
        tabLabel={tabLabel}
        title={title}
        reducerId={reducerId}
        backBtn={title && backBtn(dispatch, title)}
        crudBtnAdd={tabLabel !== 'crud-add' && crudBtnAdd(dispatch, '+ Create')}
      >
        <div className="tab" data-label="root">
          <Table
            dispatch={dispatch}
            state={tableState}
            apiCallWrapper={tableApiCallMemo}
            columns={columns}
            handleOnRowClick={(row: any) =>
              dispatch(
                crudFormSetMode({
                  tab: 'crud-update',
                  subTitle: (
                    <>
                      {row.firstName} {row.lastName}
                    </>
                  ),
                  initValues: crudInitialValuesMapper(row),
                }),
              )
            }
          />
        </div>
        <div className="tab" data-label="crud-add">
          <CrudTab>
            <CrudFormAdd
              apiCallWrapper={crudApiCall.add(dispatch)}
              dispatch={dispatch}
              reducerId={reducerId}
              validationSchema={validators(messages).dashboard.psus.add}
              params={crudFormParams(messages).add}
            />
          </CrudTab>
        </div>
        <div className="tab" data-label="crud-update">
          <CrudTab>
            <CrudFormUpdate
              apiCallWrapper={crudApiCall.update(dispatch)}
              deleteApiCallWrapper={crudApiCall.delete(dispatch)}
              dispatch={dispatch}
              reducerId={reducerId}
              validationSchema={validators(messages).dashboard.psus.update}
              params={crudFormParams(messages).update}
              backBtn={backBtn}
            />
          </CrudTab>
        </div>
      </LayoutTable>
    </LayoutDashboard>
  );
};

export default Psus;
